import { client } from '../apiClient';
import { AccountResponse } from '../../models/account/AccountResponse';

export const getAccount = async (): Promise<AccountResponse> => {
  return client(true, true)
    .get<AccountResponse>(`/account/data`)
    .then((response) => response.data);
};

export const toggleAccount = async (): Promise<boolean> => {
  return client(true, true)
    .get<boolean>(`/account/toggle`)
    .then((response) => response.data)
    .catch((error) => error);
};
